import MapBox from './map'

export class ModifyAlertsLocationModule {

    initialize() {
        this.startLocationModifyObserver()
    }

    startLocationModifyObserver() {
        const THREE_MINUTE = 3000 * 60

        window.setInterval(() => {
            this.modifyLocation()
        }, THREE_MINUTE)
    }

    modifyLocation() {
        let avsecAlertLayer = MapBox.map.getLayer('avsec-alerts')
        let internationalSosAlertLayer = MapBox.map.getLayer('international-sos-alerts')
        let incidentsLayer = MapBox.map.getLayer('incidents')

        let incidents = []
        if (incidentsLayer) {
            incidents = MapBox.map.getSource('incidents')
        }
        if (incidents?._data?.features.length > 0) {
            incidents._data.features = incidents?._data?.features.map(feature => {
                feature.type = 'INCIDENTS'
                return feature
            })
        }

        let avsecAlerts = []
        if (avsecAlertLayer) {
            avsecAlerts = MapBox.map.getSource('avsec-alerts')
        }
        if (avsecAlerts?._data?.features.length > 0) {
            avsecAlerts._data.features = avsecAlerts?._data?.features.map(feature => {
                feature.type = 'AVSECALERTS'
                return feature
            })
        }

        let internationalSosAlerts = []
        if (internationalSosAlertLayer) {
            internationalSosAlerts = MapBox.map.getSource('international-sos-alerts')
        }
        if (internationalSosAlerts?._data?.features.length > 0) {
            internationalSosAlerts._data.features = internationalSosAlerts?._data?.features.map(feature => {
                feature.type = 'SOSALERTS'
                return feature
            })
        }

        let allAlerts = [...internationalSosAlerts?._data?.features || [], ...avsecAlerts?._data?.features || [], ...incidents?._data?.features || []]
        allAlerts = this.shiftOverlappingCoordinates(allAlerts, 0.0001, 0.0001)

        let sosAlerts = allAlerts?.filter(feature => feature?.type === 'SOSALERTS')
        if (sosAlerts.length > 0) {
            internationalSosAlerts._data.features = sosAlerts
            internationalSosAlerts.setData(internationalSosAlerts._data)
        }

        let avsecAlert = allAlerts?.filter(feature => feature?.type === 'AVSECALERTS')
        if (avsecAlert.length > 0) {
            avsecAlerts._data.features = avsecAlert
            avsecAlerts.setData(avsecAlerts._data)
        }

        let incident = allAlerts?.filter(feature => feature?.type === 'INCIDENTS')
        if (incident.length > 0) {
            incidents._data.features = incident
            incidents.setData(incidents._data)
        }


    }

    shiftOverlappingCoordinates(geojsonData, shiftLat, shiftLng) {
        let checkedCoordinates = new Set()

        function isOverlapping(coord) {
            const key = coord.join(',')
            return checkedCoordinates.has(key)
        }

        function shiftCoord(lat, lon) {
            // Randomly select a meter value from the array
            let meters = 1
            // convert 1 meter to km    
            meters = meters * 1000
            // Convert meters to degrees (approximation)
            const degreesChange = meters * 0.000009

            // Generate a random angle in radians for direction
            // const angle = angleValues[Math.floor(Math.random() * angleValues.length)] * 2 * Math.PI 
            const angle = 2 * Math.PI

            // Calculate change in latitude and longitude
            const deltaLat = degreesChange * Math.cos(angle)
            const deltaLon = degreesChange * Math.sin(angle) / Math.cos(lat * Math.PI / 90)

            // Update the coordinates
            return [lat + deltaLat, lon + deltaLon]
        }

        function adjustCoordinates(coords) {
            let newCoords = coords
            while (isOverlapping(newCoords)) {
                newCoords = shiftCoord(newCoords[0], newCoords[1])
            }
            checkedCoordinates.add(newCoords.join(','))
            return newCoords
        }

        geojsonData?.forEach(feature => {
            const geomType = feature.geometry.type
            let coords = feature.geometry.coordinates

            if (geomType === 'Point') {
                feature.geometry.coordinates = adjustCoordinates(coords)
                feature.isOverlapping = isOverlapping(coords)
            } else if (geomType === 'MultiPoint') {
                feature.geometry.coordinates = coords.map(coord => adjustCoordinates(coord))
            }
        })

        return geojsonData
    }
}

const ModifyAlertsLocation = new ModifyAlertsLocationModule()
export default ModifyAlertsLocation